<template>
  <section class="user-auth" v-if="!restore_pass">
      <label class="user-auth__label">
        Пройдите авторизацию
      </label>
      <form class="user-auth__form">
        <div class="row">
          <div class="form-group col-md-6">
            <input name="name" placeholder="E-mail" type="text" v-model="form.email" class="form-control"
                   :class="errors.get('email') ? 'is-invalid':''">
            <div class="invalid-feedback" v-text="errors.get('email')"></div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <input name="password" placeholder="Пароль" type="password" v-model="form.password" class="form-control"
                   :class="errors.get('password') ? 'is-invalid':''">
            <div class="invalid-feedback" v-text="errors.get('password')"></div>
          </div>
        </div>
        <div class="form-group">
          <button class="btn user-auth__forgot-pass" @click.prevent="forgotPass">
            Забыли пароль?
          </button>
        </div>
            <button class="btn button-red user-auth__btn" @click.prevent="login">
              Войти
            </button>
      </form>
  </section>
  <section v-else>
    <div class="row">
      <div class="col-md-6">
        <label class="user-auth__label">
          Восстановление доступа
        </label>
        <p v-text="msg">

        </p>
      </div>
    </div>
    <form class="user-auth__form" v-if="!restored">

      <div class="row">
        <div class="form-group col-md-6">
          <input name="email" placeholder="E-mail" type="text" v-model="forgot.email" class="form-control"
                 :class="errors.get('email') ? 'is-invalid':''">
          <div class="invalid-feedback"  v-text="errors.get('email')"></div>
        </div>
      </div>

      <button class="btn button-red user-auth__btn" @click.prevent="resetPassword">
      Отправить
      </button>
    </form>
    <button class="btn button-red user-auth__btn" @click.prevent="restore_pass =false " v-else>
      Вернуться к авторизации
    </button>
  </section>
</template>
<script>
import { Errors } from  '@/common/services/errors.js';
export default {
  data() {
    return {
      form: {
        email:"",
        password:"",
      },
      forgot:{
        email: "",
      },
      restore_pass:false,
      errors: new Errors(),
      msg: " Введите E-mail, указанный при регистрации. Мы отправим вам новый пароль.",
      restored:false,
    }
  },
  methods: {
    forgotPass() {
      this.restore_pass = true;
    },
    login() {
      axios.post('/login', this.form)
      .then((response) => {
        this.$emit('login');
      })
      .catch((error) => {
        this.errors.record(error.response.data.errors)
      })
    },
    resetPassword() {
      axios.post('/api/user/reset-password', this.forgot)
        .then((response) => {

          if(response.data.errors) {
            this.errors.record(response.data.errors)
          } else {
            this.msg = "Мы отправили новый пароль вам на почту.";
            this.restored=true;
          }
        })
      .catch((error) => {
        console.log(error)
      })
    }
  }
}
</script>